import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

function TrainingCard({ item, lang, t, onRegister, onUnregister, onAddGuests, onShowCompanyRegs }) {
  const title = item[`title_${lang}`] || item.title_cs;
  const desc = item[`description_${lang}`] || item.description_cs;
  const dateFrom = new Date(item.date_from);
  const locale = lang === 'cs' ? 'cs-CZ' : lang === 'sk' ? 'sk-SK' : 'ro-RO';
  const spotsLeft = item.capacity - item.registered_count;
  const isFull = spotsLeft <= 0;
  const isRegistered = item.is_registered > 0;
  const isPast = dateFrom < new Date();

  return (
    <div style={{
      background: '#fff',
      borderRadius: 12,
      padding: '24px',
      boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
      border: '1px solid #f3f4f6',
      opacity: isPast ? 0.7 : 1,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#111827', lineHeight: 1.4 }}>
          {title}
        </h2>
        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
          {item.is_online ? (
            <span style={{ background: '#dbeafe', color: '#1d4ed8', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6 }}>
              {t('online')}
            </span>
          ) : (
            <span style={{ background: '#f0fdf4', color: '#166534', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6 }}>
              {t('onsite')}
            </span>
          )}
          {isPast && (
            <span style={{ background: '#f3f4f6', color: '#9ca3af', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6 }}>
              Archiv
            </span>
          )}
        </div>
      </div>

      {desc && <p style={{ margin: '0 0 16px', fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>{desc}</p>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 16px', marginBottom: 16 }}>
        {[
          ['📅', t('date'), dateFrom.toLocaleDateString(locale) + (item.date_to ? ' – ' + new Date(item.date_to).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' }) : '')],
          ['📍', t('location'), item.location],
          ['🌍', lang === 'cs' ? 'Stát' : lang === 'sk' ? 'Štát' : lang === 'hu' ? 'Ország' : 'Country', !item.is_online && item.country ? ({CZ:'Česká republika',SK:'Slovensko',RO:'România',HU:'Magyarország',PL:'Polsko',DE:'Německo',AT:'Rakousko'}[item.country] || item.country) : null],
          ['🗣️', lang === 'cs' ? 'Jazyk školení' : lang === 'sk' ? 'Jazyk školenia' : lang === 'hu' ? 'Oktatás nyelve' : 'Training language', {'cs':'🇨🇿 Čeština','sk':'🇸🇰 Slovenčina','ro':'🇷🇴 Română','en':'🇬🇧 English','hu':'🇭🇺 Magyar'}[item.lang] || item.lang],
          ['👤', t('trainer'), item.trainer],
          ['🏢', 'Pořadatel', item.organizer_name],
          ['👥', t('capacity'), `${item.registered_count}/${item.capacity} (${spotsLeft} ${t('spots')})`],
        ].map(([icon, label, value]) => value ? (
          <div key={label} style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
            <span style={{ fontSize: 14 }}>{icon}</span>
            <div>
              <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600 }}>{label}</div>
              <div style={{ fontSize: 13, color: '#374151' }}>{value}</div>
            </div>
          </div>
        ) : null)}
      </div>

      {item.company_registered_count > 0 && (
        <div onClick={() => onShowCompanyRegs(item)} style={{ marginBottom: 16, padding: '10px 14px', background: '#f0f9ff', borderRadius: 8, border: '1px solid #bae6fd', display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}
          onMouseEnter={e => e.currentTarget.style.background = '#e0f2fe'}
          onMouseLeave={e => e.currentTarget.style.background = '#f0f9ff'}>
          <span style={{ fontSize: 16 }}>🏭</span>
          <span style={{ fontSize: 13, color: '#0369a1', fontWeight: 600 }}>
            {lang === 'cs' ? `Celkem přihlášeno za vaši firmu: ${item.company_registered_count} ${item.company_registered_count === 1 ? 'osoba' : item.company_registered_count < 5 ? 'osoby' : 'osob'}` :
             lang === 'sk' ? `Celkom prihlásených za vašu firmu: ${item.company_registered_count}` :
             lang === 'hu' ? `Cégen belül regisztráltak: ${item.company_registered_count} fő` :
             `Total registered from your company: ${item.company_registered_count}`}
          </span>
          <span style={{ marginLeft: 'auto', fontSize: 12, color: '#0369a1' }}>▼ zobrazit</span>
        </div>
      )}

      {!isPast && (
        isRegistered ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{
              background: '#f0fdf4',
              color: '#166534',
              fontSize: 13,
              fontWeight: 700,
              padding: '8px 16px',
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}>
              ✓ {t('registered')}
            </span>
            <button onClick={() => onUnregister(item.id)} style={{
              background: 'none',
              border: '1px solid #e5e7eb',
              color: '#9ca3af',
              fontSize: 13,
              padding: '8px 14px',
              borderRadius: 8,
              cursor: 'pointer',
              fontFamily: 'inherit',
              transition: 'all 0.15s',
            }}
              onMouseEnter={e => { e.target.style.borderColor = '#fca5a5'; e.target.style.color = '#0e76bc'; }}
              onMouseLeave={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.color = '#9ca3af'; }}
            >
              {t('unregister')}
            </button>
            {!isFull && !isPast && (
              <button onClick={() => onAddGuests(item)} style={{
                background: '#f0f9ff',
                border: '1px solid #bae6fd',
                color: '#0369a1',
                fontSize: 13,
                padding: '8px 14px',
                borderRadius: 8,
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontWeight: 600,
              }}>
                + {lang === 'cs' ? 'Přihlásit další osoby' : lang === 'sk' ? 'Prihlásiť ďalšie osoby' : lang === 'hu' ? 'További személyek' : 'Add more people'}
              </button>
            )}
          </div>
        ) : isFull ? (
          <span style={{
            background: '#f9fafb',
            color: '#9ca3af',
            fontSize: 13,
            fontWeight: 600,
            padding: '8px 16px',
            borderRadius: 8,
            display: 'inline-block',
          }}>
            {t('full')}
          </span>
        ) : (
          <button onClick={() => onRegister(item.id)} style={{
            background: 'linear-gradient(135deg, #0e76bc, #0b5e96)',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '10px 20px',
            fontSize: 14,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
            transition: 'opacity 0.15s',
          }}
            onMouseEnter={e => e.target.style.opacity = 0.9}
            onMouseLeave={e => e.target.style.opacity = 1}
          >
            {t('register')}
          </button>
        )
      )}
    </div>
  );
}

export default function TrainingsPage() {
  const { lang, t, apiFetch } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);
  const [guestDialog, setGuestDialog] = useState(null);
  const [companyRegsDialog, setCompanyRegsDialog] = useState(null); // { title, regs }

  const load = () => apiFetch('/trainings').then(setItems).finally(() => setLoading(false));

  useEffect(() => { load(); }, [apiFetch]);

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 4000);
  };

  const handleRegister = async (id) => {
    try {
      await apiFetch(`/trainings/${id}/register`, { method: 'POST' });
      showToast(t('registerSuccess'));
      load();
    } catch (e) {
      showToast(e.message, 'error');
    }
  };

  const handleUnregister = async (id) => {
    try {
      await apiFetch(`/trainings/${id}/register`, { method: 'DELETE' });
      showToast(t('unregisterSuccess'));
      load();
    } catch (e) {
      showToast(e.message, 'error');
    }
  };

  const handleAddGuests = (training) => {
    const spotsLeft = training.capacity - training.registered_count;
    setGuestDialog({ training, step: 1, count: 1, spotsLeft, guests: [] });
  };

  const handleShowCompanyRegs = async (training) => {
    const title = training[`title_${lang}`] || training.title_cs;
    const regs = await apiFetch(`/trainings/${training.id}/company-registrations`);
    setCompanyRegsDialog({ title, regs });
  };

  const handleGuestCountConfirm = () => {
    const guests = Array.from({ length: guestDialog.count }, () => ({ first_name: '', last_name: '', email: '' }));
    setGuestDialog(d => ({ ...d, step: 2, guests }));
  };

  const handleGuestSubmit = async () => {
    try {
      await apiFetch(`/trainings/${guestDialog.training.id}/guests`, { method: 'POST', body: JSON.stringify({ guests: guestDialog.guests }) });
      setGuestDialog(null);
      showToast(lang === 'cs' ? `Přihlášeno ${guestDialog.guests.length} dalších osob.` : `${guestDialog.guests.length} people registered.`);
      load();
    } catch(e) {
      showToast(e.message, 'error');
    }
  };

  const inpStyle = { width: '100%', padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('loading')}</div>;

  return (
    <div>
      <h1 style={{ margin: '0 0 24px', fontSize: 26, fontWeight: 800, color: '#111827' }}>
        🎓 {t('trainingsTitle')}
      </h1>

      {toast && (
        <div style={{
          position: 'fixed',
          top: 80,
          right: 24,
          background: toast.type === 'error' ? '#e8f4fc' : '#f0fdf4',
          border: `1px solid ${toast.type === 'error' ? '#b3d9f2' : '#bbf7d0'}`,
          color: toast.type === 'error' ? '#dc2626' : '#166534',
          borderRadius: 10,
          padding: '14px 20px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
          zIndex: 999,
          fontSize: 14,
          fontWeight: 500,
          maxWidth: 380,
        }}>
          {toast.msg}
        </div>
      )}

      {companyRegsDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, maxWidth: 560, width: '100%', maxHeight: '80vh', overflow: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#0369a1' }}>
                🏭 {lang === 'cs' ? 'Přihlášení za vaši firmu' : 'Registered from your company'}
              </h3>
              <button onClick={() => setCompanyRegsDialog(null)} style={{ background: 'none', border: '1px solid #e5e7eb', borderRadius: 6, padding: '4px 12px', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13 }}>✕</button>
            </div>
            <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>{companyRegsDialog.title}</div>
            {companyRegsDialog.regs.length === 0 ? (
              <p style={{ color: '#9ca3af', textAlign: 'center', padding: 20 }}>Žádní přihlášení.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #f3f4f6' }}>
                    <th style={{ padding: '8px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600 }}>Jméno</th>
                    <th style={{ padding: '8px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600 }}>E-mail</th>
                    <th style={{ padding: '8px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600 }}>Typ</th>
                  </tr>
                </thead>
                <tbody>
                  {companyRegsDialog.regs.map((r, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #f9fafb' }}>
                      <td style={{ padding: '8px 10px', fontWeight: 600 }}>{r.name || '—'}</td>
                      <td style={{ padding: '8px 10px', color: '#0e76bc' }}>{r.email || '—'}</td>
                      <td style={{ padding: '8px 10px' }}>
                        {r.type === 'Host' ? (
                          <span style={{ background: '#f0f9ff', color: '#0369a1', fontWeight: 600, padding: '2px 8px', borderRadius: 10, fontSize: 11 }}>
                            Host {r.registered_by ? `(přes: ${r.registered_by})` : ''}
                          </span>
                        ) : (
                          <span style={{ background: '#f0fdf4', color: '#166534', fontWeight: 600, padding: '2px 8px', borderRadius: 10, fontSize: 11 }}>Vlastní</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {guestDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, maxWidth: 500, width: '100%', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 700, color: '#111827' }}>
              {lang === 'cs' ? 'Přihlásit další osoby' : lang === 'sk' ? 'Prihlásiť ďalšie osoby' : 'Add more people'}
            </h3>

            {guestDialog.step === 1 ? (
              <>
                <p style={{ margin: '0 0 16px', fontSize: 14, color: '#6b7280' }}>
                  {lang === 'cs' ? `Volná místa: ${guestDialog.spotsLeft}` : `Available spots: ${guestDialog.spotsLeft}`}
                </p>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>
                  {lang === 'cs' ? 'Počet dalších osob:' : 'Number of additional people:'}
                </label>
                <input type="number" min="1" max={guestDialog.spotsLeft} value={guestDialog.count}
                  onChange={e => setGuestDialog(d => ({ ...d, count: Math.min(Number(e.target.value), d.spotsLeft) }))}
                  style={{ ...inpStyle, width: 100, marginBottom: 20 }} />
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={handleGuestCountConfirm} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 20px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                    {lang === 'cs' ? 'Pokračovat' : 'Continue'}
                  </button>
                  <button onClick={() => setGuestDialog(null)} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 16px', fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>
                    {t('cancel')}
                  </button>
                </div>
              </>
            ) : (
              <>
                <p style={{ margin: '0 0 16px', fontSize: 13, color: '#6b7280' }}>
                  {lang === 'cs' ? 'Vyplňte údaje (vše nepovinné):' : 'Fill in details (all optional):'}
                </p>
                {guestDialog.guests.map((g, idx) => (
                  <div key={idx} style={{ marginBottom: 14, padding: '12px 14px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb' }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', marginBottom: 8 }}>
                      {lang === 'cs' ? `Osoba ${idx + 1}` : `Person ${idx + 1}`}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      <input placeholder={lang === 'cs' ? 'Jméno' : 'First name'} value={g.first_name}
                        onChange={e => setGuestDialog(d => { const gs = [...d.guests]; gs[idx] = {...gs[idx], first_name: e.target.value}; return {...d, guests: gs}; })}
                        style={inpStyle} />
                      <input placeholder={lang === 'cs' ? 'Příjmení' : 'Last name'} value={g.last_name}
                        onChange={e => setGuestDialog(d => { const gs = [...d.guests]; gs[idx] = {...gs[idx], last_name: e.target.value}; return {...d, guests: gs}; })}
                        style={inpStyle} />
                      <input placeholder="Email" value={g.email} style={{ ...inpStyle, gridColumn: '1/-1' }}
                        onChange={e => setGuestDialog(d => { const gs = [...d.guests]; gs[idx] = {...gs[idx], email: e.target.value}; return {...d, guests: gs}; })} />
                    </div>
                  </div>
                ))}
                <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
                  <button onClick={handleGuestSubmit} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 20px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                    {lang === 'cs' ? 'Přihlásit' : 'Register'}
                  </button>
                  <button onClick={() => setGuestDialog(d => ({...d, step: 1}))} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 16px', fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>
                    {lang === 'cs' ? 'Zpět' : 'Back'}
                  </button>
                  <button onClick={() => setGuestDialog(null)} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 16px', fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>
                    {t('cancel')}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('noTrainings')}</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 20 }}>
          {items.map(item => (
            <TrainingCard
              key={item.id}
              item={item}
              lang={lang}
              t={t}
              onRegister={handleRegister}
              onUnregister={handleUnregister}
              onAddGuests={handleAddGuests}
              onShowCompanyRegs={handleShowCompanyRegs}
            />
          ))}
        </div>
      )}
    </div>
  );
}
